import React from "react";
import { Eyebrow, Section } from "./SeoUI";

const StyleProfileSection = () => {
  return (
    <Section id="style-profile" className="bg-[#f7f7f7]">
      <Eyebrow>Module: profile_built_from_you</Eyebrow>
      <h2 className="font-inter font-medium tracking-[-2%] leading-[42px] text-[30px] md:text-[36px] text-[#313131]">
        A body-data profile. Not a vibe board.
      </h2>
      <p className="mt-4 max-w-[720px] text-[13px] font-inter md:text-[15px] leading-6 text-[#5C5C5C]">
        Eveness builds a structured profile of every shopper — physical measurements, body shape, face geometry, colour analysis, style preferences — then scores every garment against it. That score is your match percentage, attached to every product in your feed. Setup takes about 3 minutes.
      </p>
      <div className="mt-12 grid gap-4 md:grid-cols-3">
        <div className="rounded-xl border border-neutral-200 bg-white p-6">
          <div className="font-jetBrainsMono text-[10px] md:text-[11px] tracking-[8%] text-[#5C5C5C]">
            MODULE: PHYSICAL_METRICS
          </div>
          <div className="mt-4 font-jetBrainsMono font-medium text-[20px] md:text-[26px] text-[#313131]">CHRISTINE</div>       
          <div className="mt-1 font-jetBrainsMono text-[10px] md:text-[11px] tracking-[8%] text-[#5C5C5C]">
            STYLE PROFILE — INITIALISED
          </div>
          <div className="mt-9 grid grid-cols-2 gap-y-6">
            {[
              ["HEIGHT", "5′7″"],
              ["WEIGHT", "135 lbs"],
              ["BUST", "34C"],
              ["WAIST", "32″"],
              ["SHAPE", "Hourglass"],
              ["TONE", "Cool Undertone"],
            ].map(([l, v]) => (
              <div key={l}>
                <div className="font-jetBrainsMono text-[10px] md:text-[11px] text-[#5C5C5C]">
                  {l}
                </div>              
                <div className="mt-1 text-[12px] md:text-[13px] font-jetBrainsMono text-[#313131]">{v}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="rounded-xl border border-neutral-200 bg-white p-6 font-jetBrainsMono">
      

          <div className="text-[10px] md:text-[11px] tracking-[8%] text-[#5C5C5C]">
            MODULE: COLOUR_PALETTE
          </div>
    

          <div className="mt-4 font-medium text-[18px] md:text-[20px] text-[#313131]">
            ANALYSIS: DEEP WINTER
          </div>


          <div className="mt-1 text-[10px] md:text-[11px] tracking-wider text-[#5C5C5C]">
            HIGH CONTRAST · COOL UNDERTONES
          </div>

       
          <div className="mt-5 text-[10px] md:text-[11px] text-[#5C5C5C]">
            PRIMARY NEUTRALS
          </div>
          <div className="mt-2 grid grid-cols-6 gap-[6px]">
            {[
              "#000000",
              "#1F3A57",
              "#2C2A4A",
              "#5C5C5C",
              "#7B6B8C",
              "#A8B4C4",
            ].map((c) => (
              <div key={c} className="h-10 rounded min-w-[59px]" style={{ background: c }} />
            ))}
          </div>    
          <div className="mt-5 text-[10px] md:text-[11px] text-[#5C5C5C]">
            ACCENT HIGHLIGHTS
          </div>
          <div className="mt-2 grid grid-cols-5 gap-[6px]">
            {["#C5333A", "#1F8A4C", "#1F77B4", "#E91E63", "#F26633"].map(
              (c) => (
                <div
                  key={c}
                  className="h-10 rounded min-w-[71px]"
                  style={{ background: c }}
                />
              ),
            )}
          </div>
          <p className="mt-5 text-[11px] font-inter md:text-[12px] text-[#5C5C5C]">
            Detected season drives which colours score above 80% match in your feed.
          </p>
        </div>
        <div className="rounded-xl bg-[#313131] p-6 text-white font-jetBrainsMono">
          <div className="text-[10px] md:text-[11px] tracking-wider text-[#FFFFFF] opacity-[55%]">
            MODULE: FORM_FACTOR
          </div>
          <div className="mt-3 font-medium text-[21px] md:text-[24px] text-white">SHAPE: HOURGLASS</div>
          <div className="mt-1 text-[10px] md:text-[11px] tracking-[8%] text-[#5C5C5C]">
            OBJECTIVE · EMPHASISE WAISTLINE
          </div>
          <div className="mt-6 grid grid-cols-2 gap-2">
            {[
              ["V-NECKS", "Elongate torso"],
              ["WRAP", "Cinch the waist"],
              ["BODYCON", "Follow curves"],
              ["SHEATH", "Streamline frame"],
              ["EMPIRE", "Lift the bust"],
              ["BELTED", "Define centre"],
            ].map(([t, d]) => (

              <div
                key={t}
                className="rounded border border-[#FFFFFF1A] bg-[#FFFFFF0A] p-3  opacity-[1]"
              >
                <div className="text-[10px] md:text-[11px] text-[#F26633]">{t}</div>
                <div className="mt-1 font-inter text-[10px] md:text-[11px] text-[#FFFFFFD9]">{d}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default StyleProfileSection;
